import type { BadgeType, MainCategoriesType, ShortGameZipType } from '@/types'
import { shuffle } from '@/utils/helpers'

const PURCHASE_DISABLED_TOP_GAMES_HRUS = [
    'elemental-monsters-merge',
    'hedgies',
    'mahjong-classic',
    'piece-of-cake-merge--bake',
    'plants-vs-zombies-fusion-edition',
]

type TopGame = {
    hru: string
    title: string
    likes: string
    icon: string
    color: string
    badges?: BadgeType[]
}

export const topGames: TopGame[] = [
    {
        hru: 'arrow-puzzle',
        title: 'Arrow Puzzle',
        likes: '1k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-121000/icon/4f8ebbfc53d93ac32cf60e878aa87d2133fe186f0323c1a042500901f5ba6a4a?width=218',
        color: '#1E82FF',
    },
    {
        hru: 'break-a-lucky-egg-brainrots',
        title: 'Break a Lucky Egg Brainrots',
        likes: '418',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-121804/icon/932112ba31728a557743f71c20c0312c9fc7808e1d3e03ba970e9bda7528dca9?width=218',
        color: '#3AEDFF',
    },
    {
        hru: 'bubble-pop-legend',
        title: 'Bubble Pop Legend',
        likes: '1k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-117896/icon/64d32ed585debfbfbac8b499267e770227f42de8840f7e2610eb8353dfebf25e?width=218',
        color: '#DD7BFF',
    },
    {
        hru: 'elemental-monsters-merge',
        title: 'Elemental Monsters: Merge',
        likes: '479',
        icon: 'https://static.playgama.com/p-img/pg/elemental-monsters-merge/icon/bbf5336c35d14fb797e22a1b42f22980?width=218',
        color: '#1E82FF',
    },
    {
        hru: 'find-the-frog--hidden-objects',
        title: 'Find the Frog - Hidden Objects',
        likes: '9k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-99734/icon/2762d20a1481ad42ce1fc9b0436f6172c0f761881f515afded13b46c46ceeaa6?width=218',
        color: '#BEFF00',
    },
    {
        hru: 'good-sort-master',
        title: 'Good Sort Master: Triple Match',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-46/icon/c0a46a5e5ca0f818973da4fe340b68b9ab6d9cce73ea4babad9e167ef9393bd0?width=218',
        color: '#d07ffe',
        badges: ['top'],
    },
    {
        hru: 'hedgies',
        title: 'Hedgies',
        likes: '9k',
        icon: 'https://static.playgama.com/p-img/pg/hedgies/icon/ce0d70a2737746eeaf60c56208b1f4ab?width=218',
        color: '#DD7BFF',
    },
    {
        hru: 'hidden-object-my-hotel',
        title: 'Hidden Object: My Hotel',
        likes: '8k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-109352/icon/a6b9915886a795de6a12ea045ae44350672228c3efe5081d717873e61255c837?width=218',
        color: '#b03ff1',
    },
    {
        hru: 'hidden-object-street-of-secrets',
        title: 'Hidden Object: Street Of Secrets',
        likes: '1k',
        icon: 'https://static.playgama.com/p-img/pg/hidden-object-street-of-secrets/icon/2a108879f486489894de1c7ecbbdbdda?width=218',
        color: '#FFE900',
    },
    {
        hru: 'idol-livestream-doll-dress-up',
        title: 'Idol Livestream: Doll Dress Up',
        likes: '4k',
        icon: 'https://static.playgama.com/p-img/pg/idol-livestream-doll-dress-up/icon/2dc6c0c72413419ea9862d37646077f8?width=218',
        color: '#DD7BFF',
    },
    {
        hru: 'mahjong-classic',
        title: 'Mahjong Classic',
        likes: '502',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-121631/icon/d9cc661f648e2ba097c3bcf8433389c2033d164a01beb9d2ac4e4bd4ccfb8080?width=218',
        color: '#3AEDFF',
    },
    {
        hru: 'master-chess',
        title: 'Master Chess',
        likes: '2k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-86262/icon/f565a4e4737045152e0e5800694d608304b9e28d3f23ea052257e6699fd3a27c?width=218',
        color: '#45DAFF',
    },
    {
        hru: 'merge--fight',
        title: 'Merge & Fight',
        likes: '260',
        icon: 'https://static.playgama.com/p-img/pg/merge--fight/icon/a6f10782465843ee94b890c3555b4225?width=218',
        color: '#BEFF00',
    },
    {
        hru: 'millionaire-life',
        title: 'Millionaire Life',
        likes: '18k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-111970/icon/426007ed1dcaa280e411e1aacfbc836ec0572b3f27ac6ab874db3d94267f40a7?width=218',
        color: '#e7572b',
    },
    {
        hru: 'my-town-home-family-playhouse',
        title: 'My Town Home: Family Playhouse',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-86391/icon/9bc47713edeb7b4dba4a6cb5b45f9292cd98dd220aa9189824cbf1dc029d48b7?width=218',
        color: '#c8ff00',
        badges: ['top'],
    },
    {
        hru: 'nuts-puzzle-sort-by-color',
        title: 'Nuts Puzzle: Sort By Color',
        likes: '3k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-118123/icon/ff7a506d8c9fee53fbac7d16a4d7798ffbd3307850711b1deb3861b5b7d6a419?width=218',
        color: '#3AEDFF',
    },
    {
        hru: 'piece-of-cake-merge--bake',
        title: 'Piece of Cake: Merge & Bake',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-97426/icon/6067d1465ed11aebb966da2c2441cff5d9760a9c34f6ceb0fa504bca50799963?width=218',
        color: '#fff200',
        badges: ['top'],
    },
    {
        hru: 'plants-vs-zombies-fusion-edition',
        title: 'PVZ Fusion Cheats',
        likes: '7k',
        icon: 'https://static.playgama.com/p-img/pg/plants-vs-zombies-fusion-edition/icon/a86761e611934d73996044a2e0af8682?width=218',
        color: '#BEFF00',
    },
    {
        hru: 'pregnant-mother-simulator',
        title: 'Pregnant Mother Simulator',
        likes: '4k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-116004/icon/5812a503cc78ebd79b0e0dec1b7bacc261e3f9404159fc79e549a2377eaa5d13?width=218',
        color: '#F977FF',
    },
    {
        hru: 'robby-double-jump-for-brainrots',
        title: 'Robby: Double jump for brainrots',
        likes: '295',
        icon: 'https://static.playgama.com/p-img/pg/robby-double-jump-for-brainrots/icon/048ed4070dd94d1d83a10c3b21ec9ca8?width=218',
        color: '#1E82FF',
    },
    {
        hru: 'tb-world',
        title: 'TB World',
        likes: '16k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-90498/icon/3a5f27d96c92a7382fbfd3a07c58fdb40b94cb58406ca8cfc4a178a0e7fa87fe?width=218',
        color: '#1aff00',
        badges: ['hot'],
    },
    {
        hru: 'word-finder',
        title: 'Word Finder',
        likes: '2k',
        icon: 'https://static.playgama.com/p-img/pg/word-finder/icon/f9f24184faad4da2a268bed307505737?width=218',
        color: '#FFE900',
    },
]

function zipTopGames(game: TopGame): ShortGameZipType {
    return [game.hru, '', '', '', '', '', false, undefined, [], 'playgama', undefined]
}

export const createPlaygamaTopCategory = (isPurchaseEnabled: boolean) => {
    return {
        id: 'top_playgama' as MainCategoriesType,
        title: 'Playgama Top',
        location: {
            name: 'category',
            params: {
                hru: 'top_playgama',
            },
        },
        games: shuffle(
            topGames
                .filter((game) => isPurchaseEnabled || !PURCHASE_DISABLED_TOP_GAMES_HRUS.includes(game.hru))
                .map(zipTopGames),
        ),
    }
}
